import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-t border-white/5 bg-carbon py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="1yf32o39qvkkq">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1ap8ptlpfdw0h">
        <div className="text-center" data-id="element-22" data-mp="15pcknj4zryjc">
          <span className="inline-flex items-center gap-2 rounded-full bg-energy px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-carbon" data-id="element-23" data-mp="15qfadnqkvuxo">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jilt9hl48g0t" /> Included at no extra cost
          </span>
          <SectionHeading id="bonus-title" className="mt-5" data-id="element-25" data-mp="r0gfpuy8f1my">
            The {totalBonuses} Exclusive Bonuses
          </SectionHeading>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="my3bjaz4vbsa">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-2xl border border-lava/20 bg-petrol p-6 shadow-lg shadow-black/30 ${bonus.wide ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="2eqo33f3mqb05" data-mpi={index}>
                <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-28" data-mp="1vu50l8nbzlck">
                  <div className="flex items-center gap-3" data-id="element-29" data-mp="20q3mmpl6sr9t">
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-lava/40 bg-carbon text-lava" data-id="element-30" data-mp="25rj5cazw6lp1">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="3c6ae10v9batm" />
                    </span>
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-lava" data-id="element-32" data-mp="3h3tqbv8e9dix">Bonus {bonus.number}</p>
                  </div>
                  <p className="whitespace-nowrap text-xs font-bold text-muted" data-id="element-33" data-mp="1c4kk0oeevmm2">
                    <span className="line-through decoration-lava" data-id="element-34" data-mp="1c6okewd3q3hl">Real value {bonus.value}</span>
                    <span className="ml-2 rounded-md bg-energy px-2 py-1 text-[11px] font-extrabold uppercase tracking-wide text-carbon" data-id="element-35" data-mp="1q1r1mfneff9p">
                      Free
                    </span>
                  </p>
                </div>

                <h3 className="mt-4 text-lg font-bold leading-tight text-snow" data-id="element-36" data-mp="tecj8cy6p891">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-37" data-mp="175r7ay6y7zmy">{bonus.description}</p>
                {bonus.highlight && <p className="mt-3 text-sm font-bold text-energy" data-id="element-38" data-mp="12dg51ooqk1r8">{bonus.highlight}</p>}

                {bonus.items && <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-39" data-mp="enddd9oqgxt5">
                    {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-snow" data-id="element-40" data-mp="al8ospd56rdd">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-lava" aria-hidden="true" data-id="element-41" data-mp="hbhim3famax" />
                        {item}
                      </li>)}
                  </ul>}

                {bonus.groups && <div className="mt-4 grid gap-6 md:grid-cols-2" data-id="element-42" data-mp="3rqr00hawsfav">
                    {bonus.groups.map(group => <div key={group.heading} data-id="element-43" data-mp="jafdwf80zd98">
                        <p className="text-sm font-bold text-snow" data-id="element-44" data-mp="o8p9us1kqhvw">{group.heading}</p>
                        <ul className="mt-2 grid gap-1.5" data-id="element-45" data-mp="o6mlsdjzeytt">
                          {group.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-muted" data-id="element-46" data-mp="eaj8qcnldfs3">
                              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-lava" aria-hidden="true" data-id="element-47" data-mp="2u272y0b80u77" />
                              {item}
                            </li>)}
                        </ul>
                      </div>)}
                  </div>}

                {bonus.cycle && <div className="mt-5" data-id="element-48" data-mp="3ag597yay2p0d">
                    <p className="text-sm font-bold text-snow" data-id="element-49" data-mp="35i3nf5m4wbl7">{bonus.cycleLabel}</p>
                    <ol className="mt-2 flex flex-wrap items-center gap-1.5" data-id="element-50" data-mp="30jabhhmhwsn5">
                      {bonus.cycle.map((step, stepIndex) => <li key={step} className="flex items-center gap-1.5" data-id="element-51" data-mp="20lip71nrkp0" data-mpi={stepIndex}>
                          <span className="rounded-md border border-lava/40 bg-carbon px-2.5 py-1 text-xs font-extrabold uppercase tracking-wide text-lava" data-id="element-52" data-mp="3t7ekod49znul">
                            {step}
                          </span>
                          {stepIndex < bonus.cycle!.length - 1 && <ArrowRightIcon className="h-3.5 w-3.5 text-energy" aria-hidden="true" data-id="element-53" data-mp="2cu7jbfu8jhee" />}
                        </li>)}
                    </ol>
                  </div>}

                <div className="flex-1" data-id="element-54" data-mp="ne572pwczz6x" />
                {bonus.benefit && <p className="mt-4 rounded-xl border-l-4 border-lava bg-carbon/50 px-4 py-3 text-sm font-semibold text-snow" data-id="element-55" data-mp="scf5rahalhxa">
                    {bonus.benefit}
                  </p>}
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-energy bg-petrol px-6 py-6 text-center shadow-lg shadow-black/40 sm:flex-row sm:text-left" data-id="element-56" data-mp="1712x14k3v5hf">
          <div data-id="element-57" data-mp="1g0q1jz84srep">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-58" data-mp="1g29htptsf2gh">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 font-display text-3xl font-bold text-muted line-through decoration-lava decoration-2" data-id="element-59" data-mp="1kzsw2pqhjf8f">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-60" data-mp="3msqs0ufk6nxl">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-61" data-mp="3mtipkaspuvqi">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 font-display text-4xl font-bold text-energy" data-id="element-62" data-mp="3est5e18ee3um">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-63" data-mp="3op60n3jlcprh" /> FREE
            </p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-lava" data-id="element-64" data-mp="3jqcmra0e6wqs">
          Only included in this offer.
        </p>
      </div>
    </section>;
}